import ContentToPrint from './ContentToPrint';
import { withI18n } from 'react-i18next';

export default ContentToPrint;
